<template>
  <div :class="themeIsDark ? 'bg-black text-white' : 'bg-white text-black'">
    <div class="relative z-10 mb-10">
      <p class="text-xl font-bold text-center mb-6 max-w-244 md:max-w-xl mx-auto" :style="$themeStyle">
        {{ title }}
      </p>
    </div>
    <div>
      <iframe
        v-if="isEmbded"
        class="w-full"
        :src="videoUrl"
        height="380"
        frameborder="0"
      ></iframe>
      <video v-else controls class="w-full" :src="videoUrl"></video>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Mixins, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { ThemeHandler } from '../../mixins/theme-handler'
import { TranslationHandler } from '../../mixins/translation-handler'
import { PageModule, PageModuleDataVideo } from '../../types'

@Component({
  components: {
  }
})
export default class ModuleVideo extends Mixins(TranslationHandler, ThemeHandler) {
  @Prop() pageModule!: PageModule<PageModuleDataVideo>

  @Getter themePrimaryColor!: string
  @Getter themeIsDark!: boolean

  get title () {
    return this.pageModule.data[this.$tLocaleCurrent].title
  }

  get videoUrl () {
    return this.pageModule.data[this.$tLocaleCurrent].videoUrl
  }

  get isEmbded (): boolean {
    return this.videoUrl.includes('youtube.com')
  }
}
</script>
